<template>
    <b-row align-h="center">
        <b-col cols="5">
            <b-card title="Iniciar sesión" class="mt-5" v-if="validVersion">
                <div style="margin-top: 50px" v-show="loadingState">
                    <ring-loader></ring-loader>
                    <h1>Cargando...</h1>
                </div>
                <b-form @submit.prevent="onSubmit" v-show="!loadingState">
                    <b-form-group
                            class="text-left"
                            id="input-group-1"
                            label="Email:"
                            label-for="input-1">
                        <b-form-input
                                id="input-1"
                                v-model="form.email"
                                type="email"
                                required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2"
                                  label="Contraseña:"
                                  label-for="input-2"
                                  class="text-left">
                        <b-form-input
                                id="input-2"
                                type="password"
                                v-model="form.password"
                                required></b-form-input>
                    </b-form-group>

                    <vue-hcaptcha @verify="onVerify"
                                  sitekey="adf43de1-de9b-4ac9-a255-8f144bd9b7a9"
                                  theme="dark"
                                  language="es"></vue-hcaptcha>

                    <b-button type="submit" variant="success">Entrar</b-button>
                    <br><br>
                    <!--<b-button variant="outline-secondary" @click="fb_message=true">Entrar con Facebook</b-button>-->
                    <!--<br><br>
                    <div class="alert alert-secondary" v-show="fb_message">
                        <p>El acceso con facebook esta deshabilitado por el momento. Si ya cuentas con una
                            suscripción e inicias sesión mediante facebook por favor envianos un correo a <a
                                    href="mailto:contacto.legionanime@gmail.com">contacto.legionanime@gmail.com</a> para
                            ayudarte a agregar una contraseña a tu cuenta.</p>
                    </div>-->
                </b-form>
                <b-button variant="primary" @click="logInWithFacebook" ref="facebook_button">Entrar con Facebook
                </b-button>
                <br><br>
                <div class="alert alert-info">
                    <p>Recuerda que para poder acceder debes contar con una suscripción de pago que puedes
                        comprar en <a target="_blank" class="font-weight-bold"
                                      href="https://legionanime.xyz/tienda">https://legionanime.xyz/tienda</a></p>
                </div>
            </b-card>
            <b-card style="margin-top: 200px;" v-show="loadingValidVersion">
                <b-card-text :style="'font-size: 20px'">
                    <div style="margin-top: 50px">
                        <ring-loader></ring-loader>
                        <h1>Validando versión de la aplicación</h1>
                    </div>
                </b-card-text>
            </b-card>
            <b-card style="margin-top: 200px;" v-show="!loadingValidVersion && !validVersion">
                <b-card-text :style="'font-size: 20px'">
                    <div style="margin-top: 50px">
                        <h1>Para poder acceder debes descargar la última actualización desde el sitio oficial</h1>
                        <p>Versión actual: Beta-1.5</p>
                    </div>
                </b-card-text>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
  import Swal from 'sweetalert2';
  import {RingLoader} from 'vue-spinners-css';
  import VueHcaptcha from '@hcaptcha/vue-hcaptcha';

  export default {
    name: "Login",
    components: {
      RingLoader,
      VueHcaptcha,
    },
    data() {
      return {
        form: {
          email: '',
          password: '',
          base_url: process.env.VUE_APP_API_URL,
          hcaptchaToken: null,
        },
        fb_message: false,
        loadingState: false,
        validVersion: false,
        loadingValidVersion: true
      }
    },
    mounted() {
      this.onLoad();
      setTimeout(() => {
        this.$refs.facebook_button.click();
        if (this.$store.getters.auth) {
          this.$router.push('/recents');
        }
      }, 500);
    },
    methods: {
      async onVerify(data) {
        this.form.hcaptchaToken = data;
      },
      async onSubmit() {
        for (let field in this.form) {
          if (!this.form[field]) {
            Swal.fire({
              title: 'Debes llenar todos el formulario y el captcha',
              icon: 'error',
            });
            return false;
          }
        }

        this.loadingState = true;
        const url = process.env.VUE_APP_API_URL + 'login';

        try {
          let response = await this.$axios.post(url, this.form);
          this.$store.dispatch('setAuth', response.data)
            .then(() => {
              this.loadingState = false;
              this.$router.push('/recents');
            });
        } catch (error) {
          let options = {};
          this.loadingState = false;
          switch (error.response.status) {
            case 401:
              options = {
                title: 'Credenciales incorrectas',
                //text: 'Verifica que tu correo y contraseña sean correctas',
                text: error.response.data.message,
                icon: 'error',
              };
              break;
            case 403:
              options = {
                title: 'No fue posible acceder',
                text: error.response.data.message,
                icon: 'warning',
              };
              break;
            case 422:
              options = {
                title: 'Credenciales incorrectas',
                text: error.response.data.message,
                icon: 'warning',
              };
              break;
            case 429:
              options = {
                title: 'Demasiados intentos',
                text: error.response.data.message,
                icon: 'warning',
              };
              break;
            case 503:
              options = {
                title: 'App en mantenimiento',
                text: 'Por favor vuelve en un rato',
                icon: 'warning',
              };
              break;
            default:
              options = {
                title: 'No fue posible acceder',
                text: 'Si el problema persiste favor de reportar el código ' + error.response.status + ' a contacto.legionanime@gmail.com',
                icon: 'warning',
              };
              break;
          }

          Swal.fire(options);
        }
      },
      async onLoad() {
        let url = process.env.VUE_APP_API_URL + 'version/' + process.env.VUE_APP_VERSION;

        try {
          let response = await this.$axios.get(url);
          this.validVersion = response.data.valid;
          this.loadingValidVersion = false;
        } catch (error) {
          let options = {};
          switch (error.response.status) {
            case 403:
              options = {
                title: 'No fue posible acceder',
                text: error.response.data.message,
                icon: 'warning',
              };
              break;
            case 422:
              options = {
                title: 'Credenciales incorrectas',
                text: error.response.data.message,
                icon: 'warning',
              };
              break;
            case 503:
              options = {
                title: 'App en mantenimiento',
                text: 'Por favor vuelve en un rato',
                icon: 'warning',
              };
              break;
            default:
              options = {
                title: 'No fue posible acceder',
                text: 'Si el problema persiste favor de reportar el código ' + error.response.status + ' a contacto.legionanime@gmail.com',
                icon: 'warning',
              };
              break;
          }

          Swal.fire(options);
        }
      },
      async logInWithFacebook() {
        await this.loadFacebookSDK(document, "script", "facebook-jssdk");
        await this.initFacebook();
        /*window.FB.login(response => {
            if (response.authResponse) {
                console.log(response);
                this.facebookLogin(response.authResponse);
            } else {
                alert("User cancelled login or did not fully authorize.");
            }
        }, {scope: 'email'});*/
        await window.FB.login(response => this.facebookLogin(response.authResponse), {scope: 'email'});
        return false;
      },
      async initFacebook() {
        window.fbAsyncInit = async function () {
          await window.FB.init({
            //appId: "1614305495371021", //You will need to change this
            appId: process.env.VUE_APP_FACEBOOK_APP_ID, //You will need to change this
            cookie: true, // This is important, it's not enabled by default
            version: "v13.0"
          });
        };
      },
      async loadFacebookSDK(d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      },
      async facebookLogin(auth) {
        if (!auth) {
          return;
        }

        try {
          const url = process.env.VUE_APP_API_URL + 'login/facebook';
          const response = await this.$axios.post(url, {auth});
          this.$store.dispatch('setAuth', response.data)
            .then(() => {
              this.loadingState = false;
              this.$router.push('/recents');
            });
        } catch (error) {
          let options = {};
          this.loadingState = false;
          switch (error.response.status) {
            case 401:
              options = {
                title: 'Credenciales incorrectas',
                text: 'Verifica que tu correo y contraseña sean correctas',
                icon: 'error',
              };
              break;
            case 403:
              options = {
                title: 'No fue posible acceder',
                text: error.response.data.message,
                icon: 'warning',
              };
              break;
            case 429:
              options = {
                title: 'Demasiados intentos',
                text: error.response.data.message,
                icon: 'warning',
              };
              break;
            case 503:
              options = {
                title: 'App en mantenimiento',
                text: 'Por favor vuelve en un rato',
                icon: 'warning',
              };
              break;
            default:
              options = {
                title: 'No fue posible acceder',
                text: 'Si el problema persiste favor de reportar el código ' + error.response.status + ' a contacto.legionanime@gmail.com',
                icon: 'warning',
              };
              break;
          }

          Swal.fire(options);
        }
      }
    },
  }
</script>

<style scoped>

</style>
